import React, { useState, useEffect, useRef,useContext } from 'react';
import DynamicIcon from '../../components/dynamicicon';
import { Link, useNavigate,useParams  } from 'react-router-dom';
import * as Constants from '../../constants';
import { ShareContext } from '../../context/ShareContext';
import BackLoader from '../../components/backloader';
import JisButton from '../../components/controls/jisButton';
import CaseSearch from '../../components/core/case_search';
import JisEmptyList from '../../components/controls/emptylist';
import Pagenated from '../../components/pagenated';
import CaseDetails from '../../components/core/caseDetails';
import JisDialog from '../../components/dialog';
import JisYesNo from '../../components/controls/jisYesNo';
import JisCheckbox from '../../components/controls/jisCheckbox';
import moment from 'moment';
import JisDialogForm from '../../components/formdialog';
import JisTabButton from '../../components/controls/jisTabButton';
import PdfViewer from '../../components/controls/pdfviewer';

function AttorneyRequests(){
  const navigate = useNavigate();
  const {  activePage, token, profile,frequentData,setIsExpired, setAlert} = useContext(ShareContext);
  const [cases, setCases] = useState([]);
  const [tab, setTab] = useState("pending");
  const [firms, setFirms] = useState([]);
    const [loading, setLoading] =useState(false);
    const [pageIndex, setPageIndex]=useState(0);
    const [pageSize,setPageSize] = useState(Constants.PAGESIZE);
    const [count,setCount] = useState(0);
    const [states, setStates]= useState([]);

     useEffect(() => {
          if(pageIndex>=0){
            onLoad();
          }else{
            setPageIndex(0);
          }           
        }, [pageIndex,pageSize,tab]);

  const onLoad= async()=>{
              //for account registration
          try {
  
              setLoading(true);
              const resp = await fetch(`${Constants.apiUrl}/profile/firms/${tab}/${pageIndex}/${pageSize}`, { //
                  method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
              const data = await resp.json();
              setLoading(false);
              if(data.code==0){
                  //ready
                  // fee, feelines, cinfo , parties 
                setFirms(data.items)
                 if(pageIndex==0){
                  setCount(data.totalCount)
                 }
                
              } else if(data.code==-10){
                        setIsExpired(true);
                    }
              
              } catch (error) {
              setLoading(false);
              console.error(error);   
              }
          }
    const onClear=()=>{
        console.log(tab);
    }      
    return (
    <div>
     <div className='tab_body'>
        <div className='tab_section'>
            <JisTabButton isActive={tab=='pending'}  
       title="Firms" 
       isRoleBased={false} onClick={()=> setTab('pending')}/>
       <JisTabButton isActive={tab=='approved'}  title="Approved Firms" 
       isRoleBased={false} onClick={()=> setTab('approved')}/>
       <JisTabButton isActive={tab=='rejected'}  title="Rejected Firms" 
       isRoleBased={false} onClick={()=> setTab('rejected')}/>
        </div>

        <div className='tab_view'>
            {firms?.length==0 && <JisEmptyList/>}
            {firms?.length>0 && <div className='table'>
                <div class="section-cases">
                <span>Firms</span><span className='total'>{count}</span>
                </div>
                <table className="case-table">
                    <thead>
                        <tr>
                            <th>S/N</th>
                            <th>Name</th>
                            <th>Desciption</th>
                            <th>Phone</th>
                            <th>Email</th>
                            <th>State</th>
                            <th>Modifed On</th>
                            <th>Active</th>
                            <th>Public</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                     <tbody>
     {firms?.map((opt, index) => (
       <tr key={index} >
      <td>{opt.name}</td>
      <td>{opt.description}</td>
      <td>{opt.phone}</td>
      <td>{opt.email}</td>
       <td>{Constants.getItemById(states,opt.stateId)?.title}</td>
     
      <td> {Constants.momentDate(opt.modifiedOn).format('DD MMM, YYYY')}</td>
       <td>{opt.isActive==true?'Yes':'No'}</td>
        <td>{opt.isPublic==true?'Yes':'No'}</td>
     
     
     {(tab=="pending") && <td><JisButton onClick={()=>onClear(opt,index)}>Clear</JisButton></td>} 
     {tab=="approved" && <td><JisButton onClick={()=>onClear(opt,index)}>Clear</JisButton></td>} 
    {tab=="rejected" && <td><JisButton onClick={()=>onClear(opt,index)}>Clear</JisButton></td>} 
    </tr>
    ))} 
    


  </tbody>
                </table>    
                </div>}

        </div>
     </div>
    </div>
  );

}
export default AttorneyRequests;